export const ocrApiPaths = <const>{
    ocr: 'ocr/companies/:companyId/requests/:requestId/attachments/:attachmentId',
    uploadDocument: 'ocr/companies/:companyId/documents/:documentType',
    status: 'ocr/companies/:companyId/requests/:requestId/attachments/:attachmentId/status',
    suggests: 'ocr/companies/:companyId/requests/:requestId/attachments/:attachmentId/suggests',
};
